import dayjs from 'dayjs';

/**
 * Los time slots guardan hora del día ("08:00", "14:00"), no fechas.
 * Pasarlos por formatDate/dayjs los rompe ("Fecha inválida"), así que se
 * normalizan aparte y sólo se cae a dayjs cuando el valor sí es un datetime.
 */
const TIME_OF_DAY_REGEX = /^(\d{1,2}):([0-5]\d)(?::[0-5]\d)?$/;

export const formatTimeOfDay = (value?: string | null): string | null => {
  if (!value) return null;

  const raw = String(value).trim();
  if (!raw) return null;

  const match = raw.match(TIME_OF_DAY_REGEX);
  if (match) {
    const hours = Number(match[1]);
    if (hours > 23) return null;
    return `${String(hours).padStart(2, '0')}:${match[2]}`;
  }

  const parsed = dayjs(raw);
  return parsed.isValid() ? parsed.format('HH:mm') : null;
};

export interface TimeSlotLabelInput {
  code?: string | null;
  from?: string | null;
  to?: string | null;
}

/**
 * Etiqueta única de franja horaria para todas las vistas (interna y comercio),
 * con el formato `CODE HH:mm - HH:mm`.
 */
export const formatTimeSlotLabel = (
  timeSlot?: TimeSlotLabelInput | null,
  fallback: string = 'N/A'
): string => {
  if (!timeSlot) return fallback;

  const from = formatTimeOfDay(timeSlot.from);
  const to = formatTimeOfDay(timeSlot.to);
  const code = timeSlot.code?.trim() ?? '';
  const range = from && to ? `${from} - ${to}` : '';

  return [code, range].filter(Boolean).join(' ') || fallback;
};
